import React, { lazy, Suspense } from "react";
import componentLoader from "../../utilities/componentLoader";

const ScoringGroups = lazy(() =>
  componentLoader(() => import("./components/ScoringGroups")),
);

export default () => (
  <div>
    <Suspense fallback={<div />}>
      <section>
        <ScoringGroups />
      </section>
    </Suspense>
  </div>
);
